export default __webpack_public_path__ + "static/media/collection-api-integration.785797fb.png";